import Record from 'lib/record'
import Team from './team'

const Game = Record({
  card_count     : 0,
  cards_left     : 0,
  current_card   : null,
  loading        : false,
  status         : '',
  team_1         : new Team(),
  team_2         : new Team(),
  turn_score     : 0,
  time_remaining : 0
}, {
  idAttribute: 'shortcode'
})

Game.getSlot = function (game) {
  return game.turn % 2 ? 'one' : 'two'
}

Game.getRivalSlot = function (game) {
  return game.turn % 2 ? 'two' : 'one'
}

Game.getCurrentTeam = function (game) {
  return game.turn % 2 ? game.team_1 : game.team_2
}

Game.getRivalTeam = function (game) {
  return game.turn % 2 ? game.team_2 : game.team_1
}

Game.isTie = function (game) {
  return game.team_1.score === game.team_2.score
}

Game.getWinner = function (game) {
  if (Game.isTie(game)) {
    return null
  }

  return game.team_1.score > game.team_2.score ? game.team_1 : game.team_2
}

Game.getLoser = function (game) {
  if (Game.isTie(game)) {
    return null
  }

  return game.team_1.score > game.team_2.score ? game.team_2 : game.team_1
}

Game.getRoundRules = function (game) {
  return [
    "Describe the card. Don't use any words from the card, \"sounds like,\" or spell the word. You got this.",
    "Act out the card. No talking or other sounds. Use your imagination, buddy.",
    "You can only use one word. Crap."
  ][game.round - 1]
}

export default Game



/** WEBPACK FOOTER **
 ** ./web/static/app/records/game.js
 **/